import Details from "../../../../Shared/Components/Details";
import Attachments from "../../../../Shared/Components/Attachments";
import Products from "../../../../Shared/Components/Products/Products";
import History from "../../../../Shared/Components/History";
import { Comment } from "../../comments";
import { Card } from "antd";
import Link from "antd/es/typography/Link";

const navigationPages = ({
  ticket,
  disabled,
}: {
  ticket: any;
  disabled: boolean;
}) => [
  {
    key: "1",
    label: `Informações Gerais`.toUpperCase(),
    children: (
      <>
        <Details disabled={disabled} ticketInfo={ticket} type="assemble" />
        <Products products={ticket.products} ticketId={ticket.id} externalId={ticket.externalId} additions={ticket.PaymentAdditions}/>
        <Attachments
          disabled={disabled}
          ticketInfo={ticket}
          type={"assemble"}
        />
        <History ticketInfo={ticket} />
        <Comment ticketInfo={ticket} />
        </>
    ),
  },
  {
    key: "2",
    label: `Anexos`.toUpperCase(),
    children: <Attachments />,
  },
];

export default navigationPages;
